import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {GeneralDragAndDropComponent} from '../../General/g-drag-and-drop';
import {patternSymbolsImages} from '../symbols-mockup';

@Component({
  selector: 'app-generate-pattern',
  templateUrl: './generate-pattern.component.html',
  styleUrls: ['./generate-pattern.component.css']
})
export class GeneratePatternComponent extends GeneralDragAndDropComponent implements OnInit, OnChanges {

  @Input() counter: number;
  @Input() level: number;
  @Output() patternChange = new EventEmitter<number[]>();

  symbols: number[];
  pattern: number[];

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.level || changes.counter) {
      this.generateNextExercise();
    }
  }

  initValues() {
    super.initValues();
    this.symbols = [];
    this.allDragElementIds = [];
    this.pattern = [];
  }

  initPattern(length: number) {
    for (let i = 0; i < length; i++) {
      this.dropValues.push(-1);
    }
  }

  checkSolution() {
    if (this.areAllValuesSet()) {
      this.patternChange.emit(this.pattern);
    }
  }

  generateNextExercise() {
    this.initValues();

    const patternLength = this.getPatternLength();
    this.initPattern(patternLength);

    const symbolsToChooseLength = this.getSymbolsLength();
    this.symbols = this.getRandomSymbols(symbolsToChooseLength);

    // We need to call this function, otherwise the drag and drop does not work!
    this.setAllDragElementIds();
  }

  getSymbolsLength() {
    if (this.level === 1) {
      return 4;
    } else if (this.level === 2) {
      return 5;
    } else {
      return 6;
    }
  }

  getPatternLength() {
    if (this.level === 1) {
      return Math.floor((Math.random() * 2) + 2);
    } else if (this.level === 2) {
      return Math.floor((Math.random() * 2) + 3);
    } else {
      return Math.floor((Math.random() * 2) + 4);
    }
  }

  getRandomSymbols(length: number) {
    const tempSymbols = [];

    while (tempSymbols.length < length) {
      const randomSymbol = Math.floor((Math.random() * 15));

      if (tempSymbols.indexOf(randomSymbol) === -1) {
        tempSymbols.push(randomSymbol);
      }
    }

    return tempSymbols;
  }

  areAllValuesSet() {
    for (let i = 0; i < this.dropValues.length; i++) {
      if (this.dropValues[i] === -1) {
        return false;
      } else {
        this.pattern[i] = this.symbols[this.dropValues[i]];
      }
    }
    return true;
  }

  getDragElementMaxSize() {
    return 9;
  }

  setAllDragElementIds() {
    for (let i = 0; i < this.symbols.length; i++) {
      this.allDragElementIds.push('symbol_' + this.symbols[i]);
    }
  }

  getActive(i: number) {
    return this.currentBelowElement !== null && parseInt(this.currentBelowElement.id, 10) === i;
  }

  getSymbolImage(idx: number) {
    if (idx === undefined) {
      return './assets/images/pattern/empty.png';
    }
    return patternSymbolsImages[idx];
  }

  getHidden(id: number) {
    if (this.currentDragElementId === null) {
      return true;
    }

    return !(this.currentDragElementId.value === this.allDragElementIds[id]);
  }

}
